<template>
    <EditModal
        id="newsletterModal"
        title="Newsletter versenden"
        size="xl"
        scrollable
        button-text="Verteiler anlegen"
        :loading="busy"
        @ok="dataProvide"
        @show="fetch"
        @hidden="dataReset"
    >
        <template v-if="!confirm.ok">
            <section class="newsletter-receiver-list">
                <div class="stats">
                    <p>Mitglieder ingesamt: {{ items.length }}</p>
                    <p>Mitglieder ausgewählt: {{ itemsChecked }}</p>
                </div>
                <Table
                    striped
                    showFilter
                    :size="size"
                    :fields="fields"
                    :items="items"
                    :isBusy="busy"
                >
                    <template v-slot:check="{ row: row }">
                        <input
                            type="checkbox"
                            :key="row.item.id"
                            v-model="row.item.check"
                        />
                    </template>

                    <template v-slot:name="{ row: row }">
                        <template v-if="row.item.vorname">
                            {{ row.item.vorname + " " }}
                        </template>
                        {{ row.item.name }}
                    </template>

                    <template v-slot:mail="{ row: row }">
                        <template v-if="row.value">
                            <template v-if="row.item.contact.length > 1">
                                <b-select v-model="row.item.mail" :size="size">
                                    <option
                                        v-for="contact in row.item.contact"
                                        :key="contact.id"
                                        :value="contact.value"
                                        >{{ contact.value }}</option
                                    >
                                </b-select>
                            </template>
                            <template v-else>
                                <span class="pl-3">{{ row.value }}</span>
                            </template>
                        </template>
                        <template v-else
                            ><span class="pl-3"
                                >Keine E-Mail Adresse vorhanden</span
                            ></template
                        >
                    </template>

                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-th></b-th>
                            <b-th></b-th>
                            <b-th>
                                <b-alert show variant="secondary">
                                    <p>
                                        Zusätzliche/n Empfänger*in hinzufügen
                                    </p>
                                    <hr />
                                    <p class="small">
                                        Rechts können zusätzliche
                                        Empfänger*innen zu dem Newsletter
                                        hinzugefügt werden
                                    </p>
                                    <b-button
                                        variant="primary"
                                        :size="size"
                                        @click="addAdditionalItem"
                                        >Hinzufügen</b-button
                                    >
                                </b-alert>
                            </b-th>
                            <b-th class="pl-3">
                                <MitgliederSelect
                                    v-model="additionalItem"
                                    :size="size"
                                />
                            </b-th>
                        </b-tr>
                    </template>
                </Table>
            </section>
        </template>
        <template v-else>
            <NewsletterConfirm
                :processing="confirm.processing"
                :processMessage="confirm.processMessage"
                :processValue="confirm.processValue"
                :errorMessage="confirm.errorMessage"
                :editUrl="confirm.editUrl"
            />
        </template>
    </EditModal>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import EditModal from "@/components/EditModal/EditModal";
import Table from "@/components/Table/Table";
import NewsletterConfirm from "@/components/Newsletter/NewsletterConfirm";
import MitgliederSelect from "@/components/MitgliederSelect/MitgliederSelect";

const MitgliederApi = ApiFactory.get("mitglieder");
const WordpressApi = ApiFactory.get("wordpress");
const BenutzerverwaltungApi = ApiFactory.get("benutzerverwaltung");

export default {
    name: "NewsletterModal",
    mixins: [CommonView, Size],
    components: {
        EditModal,
        Table,
        NewsletterConfirm,
        MitgliederSelect
    },
    props: ["filter"],
    mounted() {
        this.dataReset();
    },
    data() {
        return {
            prefetch: false,
            api: MitgliederApi,
            fields: [
                {
                    key: "check",
                    label: "",
                    sortable: false,
                    class: "text-center"
                },
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "name",
                    label: "Name",
                    sortable: true
                },
                {
                    key: "mail",
                    label: "E-Mail",
                    sortable: false
                }
            ],
            confirm: {
                ok: false,
                processing: false,
                processMessage: "",
                processValue: 0,
                editUrl: null
            },
            additionalItem: null
        };
    },
    computed: {
        itemsChecked() {
            const checkedItems = this.items.filter(item => item.check);
            return checkedItems.length;
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await MitgliederApi.get({
                fields: "id,anrede,titel,name,vorname,contact_mail",
                filter: this.filter,
                order: "name",
                sort: "asc",
                limit: -1
            });
            if (response.ok) {
                this.items = response.json.collection.map(
                    this.parseContactInformation
                );
            }
            this.busy = false;
        },
        parseContactInformation(item) {
            if (item.contact.length > 0) {
                const preferredContact = item.contact.filter(
                    contact => contact.preferred === 1
                );
                if (preferredContact.length > 0) {
                    item.mail = preferredContact[0].value;
                } else {
                    item.mail = item.contact[0].value;
                }
                item.check = true;
            } else {
                item.mail = null;
                item.check = false;
            }
            return item;
        },
        async dataProvide(evt) {
            evt.preventDefault();

            this.busy = true;

            var templateId = null;
            var user = this.$store.getters.getAuth;
            const responseSetting = await BenutzerverwaltungApi.getSetting(
                user.username,
                "newsletter_template_id"
            );
            if (responseSetting.ok) {
                const setting = responseSetting.json.setting;
                templateId = setting.value
                    ? setting.value
                    : setting.default_value;
            } else {
                this.confirm = Object.assign({}, this.confirm, {
                    errorMessage:
                        "Die Voreinstellung konnte nicht geladen werden"
                });
                return;
            }

            this.confirm = {
                ok: true,
                processing: true,
                processMessage: "Stellt Empfängerliste zusammen",
                processValue: 30,
                editUrl: null
            };

            const receiver = {
                list: [],
                user: [],
                email_id: null
            };
            const selectedMitglieder = this.items.filter(item => item.check);
            selectedMitglieder.forEach(mitglied => {
                const receivingMitglied = {
                    anrede: mitglied.anrede,
                    titel: mitglied.titel,
                    email: mitglied.mail,
                    firstname: mitglied.vorname,
                    lastname: mitglied.name
                };
                receiver.user.push(receivingMitglied);
            });

            this.confirm = {
                ok: true,
                processing: true,
                processMessage: "Newsletter duplizieren",
                processValue: 60,
                editUrl: null
            };

            try {
                const responseDuplicate = await WordpressApi.duplicateNewsletter(
                    templateId
                );
                if (responseDuplicate.ok) {
                    const jsonDuplicate = await responseDuplicate.json();
                    receiver.email_id = jsonDuplicate.email_id;
                    this.confirm = {
                        ok: true,
                        processing: true,
                        processMessage: "Überträgt Kontakte",
                        processValue: 90,
                        editUrl: null
                    };
                } else {
                    throw new Error();
                }
            } catch (error) {
                this.confirm = Object.assign({}, this.confirm, {
                    errorMessage:
                        "Es ist ein Fehler bei der Duplizierung des Newsletters aufgetreten"
                });
                return;
            }

            try {
                const responseSubscriber = await WordpressApi.postNewsletterReceiver(
                    [receiver]
                );
                if (responseSubscriber.ok) {
                    const jsonSubscriber = await responseSubscriber.json();
                    this.confirm = {
                        ok: true,
                        processing: false,
                        processMessage: "",
                        processValue: 100,
                        editUrl: jsonSubscriber.edit_url
                    };
                } else {
                    throw new Error();
                }
            } catch (error) {
                this.confirm = Object.assign({}, this.confirm, {
                    errorMessage:
                        "Es ist ein Fehler beim Übertragen der Kontakte aufgetreten"
                });
                return;
            }
        },
        dataReset() {
            this.confirm = {
                ok: false,
                processing: false,
                processMessage: "",
                processValue: 0,
                editUrl: null
            };
        },
        async addAdditionalItem() {
            console.log(this.additionalItem);
            const selectedId = this.additionalItem;
            const response = await MitgliederApi.getSingle(selectedId, {
                fields: [
                    "id",
                    "anrede",
                    "titel",
                    "name",
                    "vorname",
                    "contact_mail"
                ]
            });
            if (response.ok) {
                // TODO: Common function for deleting meta information from response
                const item = response.json;
                delete item._links;
                delete item._embedded;

                const duplicates = this.items.filter(
                    item => item.id === selectedId
                );
                if (duplicates.length > 0) {
                    this.makeToast(
                        "Empfänger*in bereits vorhanden",
                        "Der/Die Empfänger*in ist bereits in der Liste hinterlegt",
                        "warning"
                    );
                } else {
                    this.items.push(this.parseContactInformation(item));
                }
            }
        }
    }
};
</script>
